import { useGroupsContext } from '@fs/zion-tree-groups'
import { useEffect, useState } from 'react'

export default function usePageDetailPrefix(): string | undefined {
  const [pageDetailPrefix, setPageDetailPrefix] = useState<string>()
  const { currentTreeId, isResearcherGroup } = useGroupsContext()

  useEffect(() => {
    if (currentTreeId && currentTreeId !== 'PRIVATE') {
      // Is in a group tree
      if (isResearcherGroup) {
        setPageDetailPrefix('ReT: ')
      } else {
        setPageDetailPrefix('FGT: ')
      }
    } else {
      setPageDetailPrefix('')
    }
  }, [currentTreeId, isResearcherGroup])

  return pageDetailPrefix
}
